var _defs, _circle, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "4.267 4.267 55.467 55.467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: "40%",
    cy: "35%",
    r: "65%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#e8151b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e0007"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gh",
    cx: "50%",
    cy: "30%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 27,
    fill: "url(#g)",
    stroke: "#700005",
    strokeWidth: 1.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28,
    cy: 20,
    rx: 15,
    ry: 9,
    fill: "url(#gh)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMa);
export default __webpack_public_path__ + "static/media/ma.6b780d86608ab0345556fd0166cdaf0b.svg";
export { ForwardRef as ReactComponent };